import { Button, UploadFile } from 'antd';
import React, { useState } from 'react';

import { Drawer, Form } from '@common/components';
import { DisputeType } from '@common/graphql';
import { useMutation } from '@common/hooks';
import {
  DisputeCreateMutation,
  DisputeCreateMutationArg,
  DisputeCreateMutationResponse,
} from '@pay-bill/graphql';
import { useDisputeRefetchs } from '@pay-bill/hooks';
import {
  catchFormErrorsWith,
  rejectValidationErrors,
} from '@pay-bill/services';
import { createMessage } from 'works/legacy/lib/message-helper';
import { DisputeCreateDrawerBody } from './dispute-create-drawer-body';

export type ValuesOnFinishType = {
  staffingRequestAssignmentId: string;
  invOrRinvId: string;
  entityType: string | undefined;
  worksInvoiceItemId: string | undefined;
  files: UploadFile[];
  input: {
    creationReason: string;
    disputeType: DisputeType;
    newDate: string;
    newHours: number;
    newPayCode: string;
    finalRateCents: number;
  };
};

export const DisputeCreateDrawer = ({
  open,
  onClose,
  invoiceItemId = '',
}: {
  open: boolean;
  onClose: () => void;
  invoiceItemId?: string;
}) => {
  const [form] = Form.useForm();

  const [loadingBody, setLoadingBody] = useState(false);

  const [createDispute, { loading: loadingCreate }] = useMutation<
    DisputeCreateMutationResponse,
    DisputeCreateMutationArg
  >(DisputeCreateMutation);

  const closeDrawer = () => {
    form.setFieldsValue({
      newHours: undefined,
      newPayCode: undefined,
      comment: undefined,
      finalRateCents: undefined,
    });
    onClose();
  };

  const refetchQueries = useDisputeRefetchs();

  const onFinish = async (values: ValuesOnFinishType) => {
    if (loadingCreate) {
      return;
    }

    createDispute({
      variables: values,
    })
      .then(rejectValidationErrors('createDispute'))
      .then(() => {
        createMessage('success', 'Dispute has been successfully created!');
        closeDrawer();
        refetchQueries();
      })
      .catch(
        catchFormErrorsWith(form, 'Failed to create dispute. Please try again.')
      );
  };

  return (
    <Drawer
      open={open}
      title="Send Error Dispute"
      className="dispute-create-drawer"
      onClose={closeDrawer}
      footer={
        <Button
          type="primary"
          size="large"
          onClick={form.submit}
          loading={loadingCreate}
          disabled={loadingBody}
        >
          Send Dispute
        </Button>
      }
    >
      {invoiceItemId && (
        <DisputeCreateDrawerBody
          form={form}
          onFinish={onFinish}
          invoiceItemId={invoiceItemId}
          setLoading={setLoadingBody}
        />
      )}
    </Drawer>
  );
};
